export default __webpack_public_path__ + "c93d9b7afad142ecc2e20afe31ac149a.svg";